import createFullscreenIframeButton from './FullscreenIframeButton.js';


const $tables = $('.table');
let btnText = window.tooltips ? window.tooltips.collapseText : 'Показать всё';
let btnTextReplace = window.tooltips ? window.tooltips.collapseTextReplace : 'Скрыть';

if ($('.js-title-header').length) {
    App.D.ready(function () {
        if ($('.js-page-title-video').length) {
            $('.js-page-title-video').each(function() {
                let $video = $(this);

                setTimeout(function() {
                    $video[0].play();
                }, 1400);
            });
        }

        setTimeout(function () {
            $('.js-title-header').addClass('__animation');
        }, 500);
    });
}

App.H.on('change', '.js-select-links', function () {
    window.location.href = $(this).val();
});


if ($tables.length) {
    App.W.on('load', function () {
        setTimeout(function () {
            /*console.log('win.load table');*/
            collapsibleTable();
        }, 500);
    });
}

function collapsibleTable() {
    $tables.each(function (index, el) {
        let $currTable = $(el);
        let visibleRows = $(el).data('visible-rows') || 10;
        let tdHeight = $currTable.find('tbody').find('td').eq(0).outerHeight() * visibleRows;

        if ($currTable.find('tr').length > visibleRows) {
            $currTable.find('table').wrap('<div class="collapse-table _collapse" />');

            $currTable.find('.collapse-table').css({
                height: `${tdHeight}px`
            }).parent().append(`<a href="#" class="collapse-table-show-more">${btnText}</a>`);
        }
    });

    $('.collapse-table-show-more').on('click', function (e) {
        let $currTableWrap = $(this).closest('.table');
        let visibleRows = $currTableWrap.data('visible-rows') || 10;
        let $currCollapseTable = $currTableWrap.find('.collapse-table');
        let $currTable = $currTableWrap.find('table');
        let needHeight = $currCollapseTable.is('._collapse') ? $currTable.outerHeight() : $currTable.find('tbody').find('tr').eq(0).outerHeight() * visibleRows;
        let needText = $currCollapseTable.is('._collapse') ? btnTextReplace : btnText;

        $currCollapseTable.animate({
            height: needHeight
        }, 500);

        $currCollapseTable.toggleClass('_collapse');
        $currTableWrap.find('.collapse-table-show-more').html(needText);
        e.preventDefault();
    });
}

$('.webinar').each((i, rootDom) => {
    createFullscreenIframeButton($(rootDom).find('iframe')[0], $(rootDom).find('.webinar-fullscreen')[0]);
});

if (window.show_brandquad_id) {
    if ($('[data-bq-id]').length) {
        let bqId = $('[data-bq-id]').data('bq-id');
        $('[data-bq-id]').before('<div class="mb-orange">' + bqId + '</div>');
    }
}

//  Показать блок для одной илинескольких специальностей
if (App.H.find('.js-speciality-show')) {
    $('.js-speciality-show').each(function() {
        let $block = $(this);

        // проверяем специальность в localstorage
        if ($block.attr('data-speciality')) {
            let dataSpeciality = $block.data('speciality').split('|');

            if (window.localStorage.getItem('speciality') && dataSpeciality.indexOf(window.localStorage.getItem('speciality')) >= 0 ) {
                $block.removeClass('hidden');
            }
        }

        // проверяем специальность в параметре в url
        if ($block.attr('data-speciality-url')) {
            let dataUrlSpeciality = $block.data('speciality-url').split('|');
            let params = new URLSearchParams(document.location.search);

            if (params.get('specialization')) {
                let specialization = params.get('specialization').split(',');
                console.log(dataUrlSpeciality);
                $(dataUrlSpeciality).each(function(i, el) {
                    if (specialization.indexOf(el) >= 0) {
                        $block.removeClass('hidden');
                    }
                });
            }
        }
    });
}
if (App.H.find('.js-speciality-hide')) {
    $('.js-speciality-hide').each(function() {
        let dataSpeciality = $(this).data('speciality').split('|');

        if (window.localStorage.getItem('speciality') && dataSpeciality.indexOf(window.localStorage.getItem('speciality')) >= 0 ) {
            $(this).addClass('hidden');
        }
    });
}
